import styled from "@emotion/styled";
import { Button, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  max-height: 100vh;
  @supports (height: 100dvh) {
    height: 100dvh;
    max-height: 100dvh;
  }
  text-align: center;
  background-color: ${(p) => p.theme.colors.background};
`;

export const NotFound = () => {
  return (
    <Container>
      <Helmet>
        <title>404 - Not Found</title>
        <meta
          name="description"
          content="Page not found. Sorry, the page you are looking for does not exist."
        />
      </Helmet>
      <Typography variant={"h3"} color={"primary"}>
        Page not found
      </Typography>
      <Button
        component={Link}
        to={"/"}
        variant="outlined"
        sx={{ marginTop: 4 }}
      >
        Go back
      </Button>
    </Container>
  );
};
